export default "__VITE_ASSET__890d5bbc__"